export interface CreationReunionPluriprofessionnellePersonnelSoignant {
    id?: string;
    type?: TypeEnum;
    nom?: string;
    estPresent?: boolean;
}

export enum TypeEnum {
  RessourceInterne = 'ressource_interne',
  IntervenantLieAuPatient = 'intervenant_lie_au_patient',
  IntervenantExterne = 'intervenant_externe',
}
